import { ComponentTypes } from '../componentUtils';
const allComponents = {
	SignatureAnnotationComponent: 'Yoursignature',
	CheckGroupComponent: 'Checkboxgroup',
	TextComponent: 'Text',
	DateComponent: 'Date',
	AttachmentComponent: 'Attachment',
	CheckComponent: 'Checkbox',
	SignatureComponent: 'Signature',
	CheckmarkAnnotationComponent: 'Addcheckmark',
	InitialsComponent: 'Initials',
	SelectComponent: 'Dropdown',
	TextAnnotationComponent: 'Addtext',
	PaymentComponent: 'Payment',
};
export const getFieldsDetails = components => {
	try {
		const counts = {};
		Object.entries(allComponents).forEach(([type, label]) => {
			if (type === ComponentTypes.DateComponent) {
				const dateSignedCount = components.filter(
					component =>
						component.type === ComponentTypes.DateComponent && component.isDateSigned
				).length;
				counts['DateSigned'] = dateSignedCount;
				const dateCount = components.filter(
					component =>
						component.type === ComponentTypes.DateComponent && !component.isDateSigned
				).length;
				counts[label] = dateCount;
			} else {
				counts[label] = components.filter(component => component.type === type).length;
			}
		});
		return counts;
	} catch (_error) {
		return {};
	}
};
